// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"e34b9f8f9dfd5a1279a8","245":"0ea49ecf7f02b1df68f8","453":"f7074b41cef1c722fd99"}[chunkId] + ".js";
};